import { FeatureToggleV2Type } from '../enum/FeatureToggleType'
import { create } from 'zustand'

export declare interface IFeatureToggleV2Store {
  toggleListV2: Set<FeatureToggleV2Type>
  addV2ToggleSet: (toggleSet: Set<FeatureToggleV2Type>) => void
  addV2Toggle: (toggle: FeatureToggleV2Type) => void
}

export const useFeatureToggleV2Store = create<IFeatureToggleV2Store>((_, get) => ({
  toggleListV2: new Set(),
  addV2ToggleSet: (toggleSet: Set<FeatureToggleV2Type>) => {
    useFeatureToggleV2Store.setState({ toggleListV2: new Set([...toggleSet, ...get().toggleListV2]) })
  },
  addV2Toggle: (toggle: FeatureToggleV2Type) => {
    useFeatureToggleV2Store.setState({ toggleListV2: new Set([...get().toggleListV2, toggle]) })
  },
}))
